var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navigation" }, [
    _c(
      "ul",
      _vm._l(_vm.navigation, function(item) {
        return _c(
          "li",
          { key: item.title },
          [
            item.page
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: item.page,
                        params: item.params
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$store.getters.t(item.title)))]
                )
              : [_vm._v(" " + _vm._s(_vm.$store.getters.t(item.title)) + " ")]
          ],
          2
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e5f2116", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e5f2116","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/widgets/BreadCrumbs.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5e5f2116","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/widgets/BreadCrumbs.vue
// module chunks = 0